import MyDashboardPage from "./MyDashboardPage";

export default MyDashboardPage;
